import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faUpload } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';


const FileUploadComponent = ({ onFilesSelected, usageContext }) => {
  const documentTypesList = {
    PaymentAdvance: [
      'SOLICITUD DE ANTICIPO',
      'CORREO CLIENTE',
      'COMPROBANTE DE ANTICIPO',
      'FACTURA PDF',
      'FACTURA XML',
    ],
    PaymentRequest: [
      'SOLICITUD DE PAGO',
      'CORREO CLIENTE',
      'COMPROBANTE DE PAGO',
      'FACTURA PDF',
      'FACTURA XML',
    ],
  };
  const documentTypes = documentTypesList[usageContext] || [];

  const [filesWithClassification, setFilesWithClassification] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    const filesWithInitialClassification = acceptedFiles.map(file => ({
      file,
      classification: 'UNCLASSIFIED', // Set an initial state that clearly indicates no classification
      preview: URL.createObjectURL(file),
    }));

    setFilesWithClassification(prev => [...prev, ...filesWithInitialClassification]);
    onFilesSelected([...filesWithClassification, ...filesWithInitialClassification]); // Ensure parent state is updated
}, [filesWithClassification, onFilesSelected]);


  const handleClassificationChange = (fileIndex, classification) => {
    const updatedFiles = [...filesWithClassification];
    updatedFiles[fileIndex] = { ...updatedFiles[fileIndex], classification };
    setFilesWithClassification(updatedFiles);

    
    onFilesSelected(updatedFiles);
  };

  const handleRemoveFile = (event, fileIndex) => {
    // Prevent the link from being followed
    event.preventDefault();

    // Stop event propagation to prevent opening the file dialog
    event.stopPropagation();

    // Filter out the file at the specified index
    const updatedFiles = filesWithClassification.filter((_, index) => index !== fileIndex);
    setFilesWithClassification(updatedFiles);

    // Notify parent component about the file removal
    onFilesSelected(updatedFiles);
  };

  const handleSelectClick = (e) => {
    // Stop event propagation to prevent opening the file dialog
    e.stopPropagation();
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps()} className="bg-gray-100 p-6 cursor-pointer text-center hover:shadow rounded-lg transition-shadow duration-300 ease-in-out">
      <input {...getInputProps()} />
      <p className="text-gray-700 font-semibold text-lg">
        <FontAwesomeIcon icon={faUpload} className="mr-2 text-gray-500" /> Drag 'n' drop some files here, or click to select files
      </p>
      {filesWithClassification.length > 0 && (
        <div className="mt-4">
          <h4 className="font-semibold text-gray-800 mb-3">Selected Files:</h4>
          {filesWithClassification.map((fileWithClassification, index) => (
            <div key={index} className="flex justify-between items-center bg-white p-3 rounded-md mb-2 shadow border">
              <span className="w-5/12 text-left text-gray-800 font-medium truncate">{fileWithClassification.file.name}</span>
              <span className="w-2/12 text-left text-sm text-gray-600">{(fileWithClassification.file.size / 1024).toFixed(2)} KB</span>
              <div className="w-3/12 text-left">
                <select
                  value={fileWithClassification.classification}
                  onChange={(e) => handleClassificationChange(index, e.target.value)}
                  onClick={handleSelectClick}
                  className="w-full border border-gray-300 rounded-md text-gray-600 bg-white shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
                >
                  <option value="">Select Document Type</option>
                  {documentTypes.map((type, typeIndex) => (
                    <option key={typeIndex} value={type}>{type}</option>
                  ))}
                </select>
              </div>
              <button
                onClick={(event) => handleRemoveFile(event, index)}
                className="text-red-500 hover:text-red-700 transition-colors duration-150"
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </button>

            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileUploadComponent;
